import { useMemo } from 'react';
import { LatLng, LatLngTuple } from 'leaflet';
import { SweepingPolyline } from '../SweepingPolyline/SweepingPolyline';

const ARC_SEGMENTS = 50;
const ARC_CURVATURE = 0.2;
const ARC_BASE_COLOR = '#D4691A';
const ARC_SWEEP_COLOR = '#F5C842';

const buildCurvedPath = (startLat: number, startLng: number, endLat: number, endLng: number): LatLngTuple[] => {
  const dLat = endLat - startLat;
  const dLng = endLng - startLng;

  const controlLat = (startLat + endLat) / 2 + dLng * ARC_CURVATURE;
  const controlLng = (startLng + endLng) / 2 - dLat * ARC_CURVATURE;

  return Array.from({ length: ARC_SEGMENTS + 1 }, (_, i) => {
    const t = i / ARC_SEGMENTS;
    const oneMinusT = 1 - t;
    return [
      oneMinusT * oneMinusT * startLat + 2 * oneMinusT * t * controlLat + t * t * endLat,
      oneMinusT * oneMinusT * startLng + 2 * oneMinusT * t * controlLng + t * t * endLng,
    ] as LatLngTuple;
  });
};

type RouteArcProps = {
  start: LatLng;
  end: LatLng;
};

export const RouteArc = ({ start, end }: RouteArcProps) => {
  const curvedPath = useMemo(
    () => buildCurvedPath(start.lat, start.lng, end.lat, end.lng),
    [start.lat, start.lng, end.lat, end.lng],
  );

  return (
    <SweepingPolyline
      positions={curvedPath}
      baseColor={ARC_BASE_COLOR}
      sweepColor={ARC_SWEEP_COLOR}
      maxSegments={ARC_SEGMENTS}
    />
  );
};
